import React, { FC } from 'react';

import { Box } from '@rbilabs/component-library';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import Modal from 'components/modal';
import Picture from 'components/picture';
import { ContentContainer } from 'components/store-card-icons/styled';
import { useFeatureLayout } from 'hooks/use-feature-layout';
import useMediaQuery from 'hooks/use-media-query';

import { GeolocationImageContainer, HeaderCaption } from './styled';
import { IGeolocationModalViewProps } from './types';

export const GeolocationModalView: FC<IGeolocationModalViewProps> = ({
  dismissModal,
  handleGeolocationPrompt,
  selectManually
}) => {
  const isMobile = useMediaQuery('mobile');
  const { formatMessage } = useIntl();
  const { featureLayout } = useFeatureLayout();
  const imageId = featureLayout?.geolocationModalImage?.locale;
  const modalHeading = formatMessage({ id: 'allowLocationServicesToFind' });
  const allowLocationServices = formatMessage({ id: 'allowLocationServices' });

  return (
    <Modal
      onDismiss={dismissModal}
      mParticleEventData={{
        modalAppearanceEventMessage: 'Allow location services'
      }}
      data-testid="geolocation-modal"
    >
      <ContentContainer>
        <HeaderCaption>
          <h5 data-testid="modal-heading" id="modal-heading">
            {modalHeading}
          </h5>
          <h2>{formatMessage({ id: 'ourRestaurantsNearYou' })}</h2>
        </HeaderCaption>
        <GeolocationImageContainer>
          {!!imageId && <Picture image={imageId} alt={allowLocationServices} />}
        </GeolocationImageContainer>
        <Box width="100%" minWidth="auto" center margin="0 0 0.625rem">
          <ActionButton
            onlyIcon={isMobile}
            data-testid="geolocation-allow"
            onClick={handleGeolocationPrompt}
          >
            {allowLocationServices}
          </ActionButton>
        </Box>
        <Box>
          <ActionButton
            transparent
            color="disabledLabel"
            variant={ActionButtonVariants.TEXT_ONLY}
            data-testid="geolocation-manual"
            onClick={selectManually}
          >
            {formatMessage({ id: 'selectManually' })}
          </ActionButton>
        </Box>
      </ContentContainer>
    </Modal>
  );
};
